import { createFileRoute } from "@tanstack/react-router";
import { CelebrityResultPage } from "@/components/site/CelebrityResultPage";
import { jimCornelison } from "@/lib/celebrity-results/jim-cornelison";
import { absoluteUrl } from "@/lib/absolute-url";

const TITLE = "Jim Cornelison Hair Transplant Results | RESTORE® Hair";
const DESC = "See national anthem singer Jim Cornelison's RESTORE® No-Shave FUE™ hair transplant results, before & after photos and his full hair restoration story.";
const POSTER = "/img/r/wp-2024-09-restore-jim-cornelison-after-photo-108-1.webp";

export const Route = createFileRoute("/results/jim-cornelison")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "article" },
      { property: "og:url", content: "https://restorehair.com/results/jim-cornelison/" },
      { property: "og:image", content: absoluteUrl(POSTER) },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: absoluteUrl(POSTER) },
    ],
    links: [
      { rel: "canonical", href: "https://restorehair.com/results/jim-cornelison/" },
    ],
  }),
  component: () => <CelebrityResultPage data={jimCornelison} />,
});
